/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Add_CriteriaInputs */

const en_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Criteria`)
};

const de_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Kriterium hinzufügen`)
};

const fr_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter un critère`)
};

const es_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Agregar criterio`)
};

const it_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi criterio`)
};

const nl_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Criterium toevoegen`)
};

const pl_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj kryterium`)
};

const fi_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää hakukriteeri`)
};

const da_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilføj kriterier`)
};

const sv_jobs_add_criteria = /** @type {(inputs: Jobs_Add_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lägg till kriterium`)
};

/**
* | output |
* | --- |
* | "+ Add Criteria" |
*
* @param {Jobs_Add_CriteriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_add_criteria = /** @type {((inputs?: Jobs_Add_CriteriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Add_CriteriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_add_criteria(inputs)
	if (locale === "fr") return fr_jobs_add_criteria(inputs)
	if (locale === "es") return es_jobs_add_criteria(inputs)
	if (locale === "it") return it_jobs_add_criteria(inputs)
	if (locale === "nl") return nl_jobs_add_criteria(inputs)
	if (locale === "pl") return pl_jobs_add_criteria(inputs)
	if (locale === "fi") return fi_jobs_add_criteria(inputs)
	if (locale === "da") return da_jobs_add_criteria(inputs)
	if (locale === "sv") return sv_jobs_add_criteria(inputs)
	return en_jobs_add_criteria(inputs)
});